import { FC, useEffect, useState } from 'react'
import { TwoColumnedDiv } from 'entities/TwoColumnedDiv'
import { usePaymentConfigStore } from 'shared/store/paymentSlice'
import { GET } from 'shared/api/GET'
import { AdyenStoreType } from 'shared/store/types'
import { Select } from 'entities/Select'

export const HSPay: FC = () => {
  const hsPay = usePaymentConfigStore().paymentConfig.hsPay
  const isConfigDataLoading = usePaymentConfigStore().isConfigDataLoading
  const updateHSPayConfig = usePaymentConfigStore().updateHSPayConfig

  const handleUpdate = (value: string) => {
    console.log('🚀 ~ value:', value, typeof value)
    updateHSPayConfig(value)
  }

  const [storeList, setStoreList] = useState<AdyenStoreType[]>([])

  const getStores = async () => {
    const stores = await GET.adyenStores()
    console.log('🚀 ~ stores:', stores)
    setStoreList(stores)
  }

  useEffect(() => {
    getStores()
  }, [])

  return (
    <TwoColumnedDiv key={`hsPay_input_${isConfigDataLoading}`}>
      <Select
        label='Selected Store'
        value={hsPay?.shopId}
        onChange={value => handleUpdate(`${value}`)}
        options={storeList?.map(s => ({ label: s.storeName, value: s.storeId }))}
      />
    </TwoColumnedDiv>
  )
}

const availableOptions: any = []
